import { render, staticRenderFns } from "./SnListModel.vue?vue&type=template&id=1ca488f0&scoped=true"
import script from "./SnListModel.vue?vue&type=script&lang=js"
export * from "./SnListModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca488f0",
  null
  
)

export default component.exports